import { StringHelper } from "@bryntum/schedulerpro";

import {
  EnterpriseManningVesselsService,
  ManningVesselCategoryService,
} from "../../../services/master";
import { CrewFilterService } from "../../../services/vessels/CrewFilterService";
import CrewsFilter from "./CrewsFilter";

/**
 * 船舶の列定義
 * @param {Object} vc - Vueコンポーネント
 */
export default vc => {
  const _vc = vc;
  let _crewFilterData = [];

  const applyCrewFilter = (crewFilterData, resourceStore) => {
    _crewFilterData = crewFilterData;

    // リソースのvisibleプロパティを更新
    crewFilterData.forEach(item => {
      const record = resourceStore.getById(item.id);
      record.set("visible", item.visible);
    });
    // フィルタを適用
    resourceStore.filter({
      filters: resource => resource.visible,
      replace: true,
    });
  };

  const build = () => {
    return [
      {
        type: "tree",
        text: "船名/役職",
        width: 220,
        field: "name",
        locked: true,
        editor: false,
        htmlEncode: false,
        // リソースのヘッダーにフィルターボタンを表示
        headerWidgets: [
          {
            type: "button",
            icon: "b-fa-filter b-fa-fw",
            cls: "b-transparent",
            color: "b-gray",
            style: {
              "margin-inline-start": "auto",
            },
            onClick: ({ source }) => {
              // フィルターボタンがクリックされたときに船員フィルタモーダルを表示
              const resourceStore = _vc.$refs.scheduler.instance.resourceStore;
              const popup = new CrewsFilter({
                data: _crewFilterData,
                owner: source,
                // applyボタンがクリックされたときの処理
                applyClicked: items => {
                  const role_positions = items.map(item => {
                    return {
                      id: item.id.split("_")[1], // p_12345 -> 12345
                      display_in_manning_table: item.visible,
                    };
                  });

                  CrewFilterService.putManningVesselRolePositionDisplay({
                    role_positions,
                  });

                  applyCrewFilter(items, resourceStore);

                  // フィルターモーダルを閉じる
                  popup.destroy();
                },
              });
              //popup.update(); // フィルターモーダルのリストを更新
              // モーダル表示
              popup.show();
            },
          },
        ],
        // 船舶情報にマウスオーバした時のみツールチップを表示する
        tooltipRenderer: renderData => {
          const { record } = renderData;
          if (!record.isLeaf) {
            // v__で始まるリソースIDから船舶IDを取得
            // 例: v__12345 -> 12345
            const vesselId = record.id.split("_")[1];
            const vessel = EnterpriseManningVesselsService.findById(vesselId);

            // 船舶名
            let vesselName = "-";
            // 船種
            let originName = "-";
            // 総トン数
            let grossTonnage = "-";
            // 機関出力数
            let enginePower = "-";
            // 自動操舵装置
            let autoPilot = "-";
            // 航行区域
            let navigationArea = "-";
            // 航行時間
            let navigationTime = "-";
            // 定員数
            let capacity = "-";

            if (vessel) {
              vesselName = vessel.name || "-";
              grossTonnage = vessel.gross_tonnage || "-";
              enginePower = vessel.engine_power || "-";
              autoPilot = vessel.auto_pilot ? "有り" : "無し";
              navigationArea =
                EnterpriseManningVesselsService.getNavigationAreaName(vessel) ||
                "-";
              navigationTime =
                EnterpriseManningVesselsService.getNavigationTimeName(vessel) ||
                "-";
              capacity = vessel.capacity || "-";

              const vesselCategory = ManningVesselCategoryService.findById(
                vessel.origin_code
              );
              if (vesselCategory) {
                originName = _vc.$t(
                  `Views.Crew.${vesselCategory.localized_key}`
                );
              }
            }

            // 船舶情報のテーブルを作成
            const vesselInfoContens = [
              {
                name: "船名",
                value: vesselName,
              },
              {
                name: "船種",
                value: originName,
              },
              {
                name: "総トン数",
                value: grossTonnage + "総トン数",
              },
              {
                name: "機関出力数",
                value: enginePower + "kw",
              },
              {
                name: "自動操舵装置",
                value: autoPilot,
              },
              {
                name: "航行区域",
                value: navigationArea,
              },
              {
                name: "航行時間",
                value: navigationTime,
              },
              {
                name: "定員数",
                value: capacity + "名",
              },
            ];

            const vesselInfoElements = vesselInfoContens
              .map(item => {
                return `<tr>
                            <td>${item.name} :</td>
                            <td style="padding: 0px 0px 0px 20px;white-space: nowrap;">${item.value}</td>
                          </tr>`;
              })
              .join("");

            const vesselInfoTable = `
                                <div style="font-weight:bold;">船舶基本情報</div>
                                <table style="border-collapse: collapse;width: auto;">
                                    ${vesselInfoElements}
                                </table>
                            `;

            return vesselInfoTable;
          }
          return "";
        },
        // リソースのセル表示カスタマイズ
        renderer: renderData => {
          const { record } = renderData;
          // 船舶の場合は、infoアイコン,下線付き青文字で表示
          if (!record.isLeaf) {
            return StringHelper.xss`
            <b style="color:blue;text-decoration:underline solid blue;">${record.name}</b>`;
          }

          return renderData.value;
        },
      },
    ];
  };

  return {
    build,
    applyCrewFilter,
  };
};
